import React, { useContext } from 'react'
import { Box, Grid, useBreakpointValue } from '@chakra-ui/react'
import { LayoutContext } from './Layout'

export const LayoutGroup = ({ children }) => {
  const { isRightPanelOpen, isLeftPanelOpen } = useContext(LayoutContext)

  const gridTemplateColumnsConfig = useBreakpointValue({
    base: `
          ${isLeftPanelOpen ? '400px' : '0px'} 
          ${isRightPanelOpen ? 'calc(100% - 720px)' : '1fr'} 
          ${isRightPanelOpen ? '320px' : '0px'}
        `,

    xl: `
          ${isLeftPanelOpen ? '400px' : '0px'} 
          ${
            isRightPanelOpen && !isLeftPanelOpen
              ? 'calc(100% - 320px)'
              : isLeftPanelOpen && isRightPanelOpen
              ? 'calc(100% - 720px)'
              : '1fr'
          }
          ${isRightPanelOpen ? '320px' : '0px'}
        `,
  })

  return (
    <Box
      position="relative"
      width="100vw"
      transition=".3s width"
      maxW="100vw"
      maxH="100vh"
      overflow="hidden"
    >
      <Grid
        h="100%"
        overflowY="auto"
        gridTemplateColumns={gridTemplateColumnsConfig}
      >
        {children}
      </Grid>
    </Box>
  )
}
